import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../field.interface';

@Component({
  selector: 'calsoft-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  @Input() field: FieldConfig;
  @Input() group: UntypedFormGroup;
  @Input() index: any;
  @Input() indexInital: any;
  @Output() valueChange = new EventEmitter<any>();

  optionsList: string[] = [];
  localFormControl: FormControl;
  reInit: boolean = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.field && changes.field.currentValue) {
      this.initializeOptions();
    }
  }
  
  ngOnInit() {
    this.localFormControl = new FormControl('');
    this.initializeOptions();
  }

  private initializeOptions(): void {
    let value: any = this.field.options;
    this.optionsList = value ? value.split(',') : [];
    this.localFormControl.setValue(this.group.value[this.field.name] || '');
    this.reInit = true;
  }

  isRequired(fieldName: string): boolean {
    const control = this.group.get(fieldName);
    return control && control.hasError('required');
  }

  setValue(value: string): void {
    const control = this.group.get(this.field.name);
    if (control) {
      control.setValue(value);
      this.valueChange.emit(this.field.name);
    }
  }
}
